import { createSlice } from '@reduxjs/toolkit';
import { CardsMarketplaceOffer } from 'src/types/marketplace';

export type MarketplaceOffers = CardsMarketplaceOffer[];
const initialState: MarketplaceOffers = [];

const marketplaceOffers = createSlice({
  name: 'marketplaceOffers',
  initialState,
  reducers: {},
});

export default marketplaceOffers.reducer;
